import type { FC } from 'react';

import InputDateTime from '../../../input_date_time/input_date_time';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'dateFormat',
  'outputFormat',
  'isRangeMode',
  'initialMonth',
  'matchSelectValue',
  'formatSelectValue',
  'onValueChange',
  // validations prop used to disable unavailable dates in calendar
  // according to minDate and maxDate
  'validations',
  'relativeToDate',
  'isDynamicWidth',
  'withTimePicker',
] as const;

const Field = formField(InputDateTime, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type DateTimeFieldWrapperProps = FieldWrapperProps<typeof Field>;

const DateTimeFieldWrapper: FC<DateTimeFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default DateTimeFieldWrapper;
